import { Button as ButtonMUI } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Error as ErrorMUI } from '@material-ui/icons';

import styled from 'styled-components';

import { mediaQueries, fontFamily } from '../../libs';

export const Container = styled(Dialog)`
  & .MuiDialog-paper {
    @media (max-width: ${mediaQueries.smTablet}px) {
      margin-left: 4px !important;
      margin-right: 4px !important;
    }
  }

  * {
    font-family: ${fontFamily};
  }
`;

export const Content = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  padding: 0 8px;
`;

export const DialogTitleStyled = styled(DialogTitle)`
  padding: 10px 15px !important;

  h2 {
    font-family: ${fontFamily} !important;
    font-weight: bold !important;
    color: #555555;
  }
`;

export const DialogContentStyled = styled(DialogContent)`
  color: #555555 !important;
  font-size: 14px !important;
  padding: 6px !important;
`;

export const DialogActionsStyled = styled(DialogActions)`
  justify-content: center !important;
  margin: 0 !important;
  padding: 10px !important;
`;

export const ErroIcon = styled(ErrorMUI)`
  color: ${({ iconcolor }) => iconcolor || '#ff2c29'} !important;
  font-size: 40px !important;
`;

export const Button = styled(ButtonMUI)`
  font-size: 13px !important;
  padding: 5px 10px !important;
  font-weight: bold !important;
  border: ${({ border }) => border || 'none'} !important;
  color: ${({ textcolor }) => textcolor || '#ffffff'} !important;
  min-width: 100px !important;
  width: ${({ width }) => width};
  background: ${({ background, theme }) => background || theme.colors.primary} !important;
  margin: 0 5px !important;
`;
